import { useCurrentUserQuery } from '@alice-financial/alice-sdk'
import { PageBody, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { Navigate } from 'react-router'
import { orgRootPath, useOrg } from '../organization/useOrg'
import { OrderForm } from './OrderForm'

export const OrderFormPage = () => {
  const { data: currentUserData } = useCurrentUserQuery()
  const currentUser = currentUserData?.currentUser
  const org = useOrg()
  if (!org || !currentUser) return null
  if (org.contractSignedOn || org.isOnboarded) {
    return <Navigate to={`${orgRootPath(org.id)}`} />
  }
  return (
    <PageBody maxWidth={1200}>
      <Typography variant="h1">Pretax Hero Order Form</Typography>
      <OrderForm accepterId={currentUser.id} />
    </PageBody>
  )
}
